import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiV2Module } from '@app/ui-v2/ui-v2.module';
import { UiModule } from '@app/ui/ui.module';
import { IconsModule } from '@app/icons/icons.module';
import { LeadBoostComponent } from '@app/lead-boost/components/lead-boost/lead-boost.component';
import { LeadBoostIndicatorComponent } from '@app/lead-boost/components/lead-boost-indicator/lead-boost-indicator.component';
import { LeadBoostPauseComponent } from './components/lead-boost-pause/lead-boost-pause.component';
import { PipesModule } from '@app/ui/pipes/pipes.module';

const declarations = [LeadBoostComponent, LeadBoostIndicatorComponent, LeadBoostPauseComponent];

@NgModule({
  declarations,
  providers: [],
  imports: [CommonModule, UiModule, UiV2Module, IconsModule, PipesModule],
  exports: declarations,
})
export class LeadBoostModule {}
